export default __webpack_public_path__ + "static/media/logo-dark.f248392e.png";